export const mapConditionsToOptions = (conditions) => {
    let result = [];
    for (const [key, conditionCollection] of Object.entries(conditions)) {
        conditionCollection.forEach(operator => {
            result.push({
                value: operator.operator,
                label: operator.label,
                group: 'group_' + key,
                operator: operator.operator,
                type: operator.type
            });
        });
    }
    return result;
};
